const useBreadcrumbs = (): void => {
  const buttons = document.querySelectorAll('.breadcrumbs__ellipsis-button') as NodeListOf<HTMLButtonElement>;

  buttons.forEach(button => {
    button.addEventListener('click', (): void => {
      const breadcrumbs = button.closest('.breadcrumbs') as HTMLElement | null;

      if (!breadcrumbs) {
        return;
      }

      const firstRevealedLink = breadcrumbs.querySelector('.breadcrumbs__item--hidden a.breadcrumbs__link') as HTMLElement | null;
      const focusTarget = firstRevealedLink ?? breadcrumbs;

      if (focusTarget === breadcrumbs) {
        breadcrumbs.setAttribute('tabindex', '-1');
      }

      breadcrumbs.classList.add('breadcrumbs--open');
      button.setAttribute('aria-expanded', 'true');

      focusTarget.focus();
    });
  });
};

useBreadcrumbs();